import { FormInputTypes } from '@components/_old/dynamicForm';
import {
  EnhancedTableHeader,
  EnhancedTableHeaderType,
} from '@components/table/widgets/shared-with-old';
import { IListingFilterWidgetSection } from '@components/widgets/listing-filter-widget';
import { IAbstractRecord } from '@models';

export const headers: Record<string, EnhancedTableHeader> = {
  SalesforceManagement_BusinessPartner_Code: {
    name: 'salesforceManagement_BusinessPartner_Code',
    title: 'Code',
    type: EnhancedTableHeaderType.Link,
    urlTemplate:
      '/salesforce/business-partners/{salesforceManagement_BusinessPartner_Id}',
    openUrlInNewTab: false,
  },
  Person_FullName: {
    name: 'person_FullName',
    title: 'Name',
    type: EnhancedTableHeaderType.Link,
    urlTemplate:
      '/salesforce/business-partners/{salesforceManagement_BusinessPartner_Id}',
    openUrlInNewTab: false,
  },
  SalesforceManagement_BusinessPartner_RelatedCompany: {
    name: 'salesforceManagement_BusinessPartner_RelatedCompany',
    title: 'Related Company',
    type: EnhancedTableHeaderType.Text,
  },
  SalesforceManagement_BusinessPartner_Type: {
    name: 'salesforceManagement_BusinessPartner_Type',
    title: 'Type',
    type: EnhancedTableHeaderType.Text,
  },
  Person_Email: {
    name: 'person_Email',
    title: 'Email',
    type: EnhancedTableHeaderType.Text,
  },
  Person_PhoneDetails: {
    name: 'person_PhoneDetails',
    title: 'Phone Number',
    type: EnhancedTableHeaderType.PhoneNumber,
  },
  SalesforceManagement_BusinessPartner_Status: {
    name: 'salesforceManagement_BusinessPartner_Status',
    title: 'Status',
    type: EnhancedTableHeaderType.Text,
  },
  SalesforceManagement_BusinessPartner_createdOn: {
    name: 'salesforceManagement_BusinessPartner_createdOn',
    title: 'Created On',
    type: EnhancedTableHeaderType.Date,
  },
  SalesforceManagement_BusinessPartner_modifiedOn: {
    name: 'salesforceManagement_BusinessPartner_modifiedOn',
    title: 'Modified on',
    type: EnhancedTableHeaderType.Date,
  },
};

export function filterSectionsContent(
  lovs: Record<string, Record<string, string>>,
  filterValues: IAbstractRecord
): IListingFilterWidgetSection[] {
  const newFilterSections: IListingFilterWidgetSection[] = [
    {
      title: 'Filters',
      inputs: {
        type: {
          name: 'type',
          title: 'Type',
          type: FormInputTypes.newmultiselect,
          value: filterValues?.type || [],
          placeholder: 'Type',
          triggerUpdate: true,
          selectOptions: { ...lovs.type },
        },
        company: {
          name: 'company',
          title: 'Company',
          type: FormInputTypes.newmultiselect,
          value: filterValues?.company || [],
          placeholder: 'Company',
          triggerUpdate: true,
          selectOptions: { ...lovs.company },
        },
        status: {
          name: 'status',
          title: 'Status',
          type: FormInputTypes.newmultiselect,
          value: filterValues?.status || [],
          placeholder: 'Status',
          triggerUpdate: true,
          selectOptions: { ...lovs.status },
        },
        isCompany: {
          name: 'isCompany',
          title: 'Is Company',
          type: FormInputTypes.newmultiselect,
          value: filterValues?.isCompany || [],
          placeholder: 'Is Company',
          triggerUpdate: true,
          selectOptions: { true: 'Yes', false: 'No' },
        },
        isLocal: {
          name: 'isLocal',
          title: 'Is Local',
          type: FormInputTypes.newmultiselect,
          value: filterValues?.isLocal || [],
          placeholder: 'Is Local',
          triggerUpdate: true,
          selectOptions: { true: 'Yes', false: 'No' },
        },
        isRegistered: {
          name: 'isRegistered',
          title: 'Is Registered',
          type: FormInputTypes.newmultiselect,
          value: filterValues?.isRegistered || [],
          placeholder: 'Is Registered',
          triggerUpdate: true,
          selectOptions: { true: 'Yes', false: 'No' },
        },
        createdOn: {
          name: 'createdOn',
          title: 'Created On',
          type: FormInputTypes.newdaterange,
          value: filterValues.createdOn || [],
          placeholder: 'Created On',
          triggerUpdate: true,
        },
      },
    },
  ];
  return newFilterSections;
}
